import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
import LeftSide from "../Components/Layouts/LeftSide.tsx";
import { Box } from "@mui/material";
import LoginScreen from "../Components/Layouts/Login.tsx";
import CreateShopper from "../Components/Layouts/CreateShopper.tsx"
import { OutputTwoTone } from "@mui/icons-material";
import Otp from "../Components/Layouts/Otp.tsx";
import SetPassword from "../Components/Layouts/SetPassword.tsx";
import Applicationform from "../Components/MainComponents/Applicationform.tsx";
import Applicationform2 from "../Components/MainComponents/Applicationform2.tsx"
import Terms from "../Components/MainComponents/Terms.tsx"
import ProtectedRoute from "./ProtectedRoutes.tsx";
import { Provider } from "react-redux";
import store from "../Redux/Store.tsx";
import PrivateRoute from "./PrivateRoutes.tsx";
import ShopperExperience from "../Components/MainComponents/ShopperForm/ShopperExperience.tsx";
import CreateOrEditScoreCard from "../Components/MainComponents/ScoreCardComponents/CreateOrEditScoreCard.tsx";
import Layout from "../Components/Layouts/Layout.tsx";
import MyTask from "../Components/MainComponents/DashboardComponents/MyTask.tsx";
import ApplyTask from "../Components/MainComponents/DashboardComponents/ApplyTask.tsx";
import Calendar from "../Components/MainComponents/DashboardComponents/Calendar.tsx";
import Invitations from "../Components/MainComponents/DashboardComponents/Invitations.tsx";
import FixIt from "../Components/MainComponents/DashboardComponents/FixIt.tsx";
import Transport from "../Components/MainComponents/DashboardComponents/Transport.tsx";
import Questions from "../Components/MainComponents/Questions.tsx";
import ScoreCard from "../Components/MainComponents/DashboardComponents/ScoreCard.tsx";
import Invoices from "../Components/MainComponents/DashboardComponents/Invoice/Invoices.tsx";
import Profile from "../Components/Header/ProfileUpdate/Profile.tsx";
import Dashboard from "../Components/MainComponents/DashboardComponents/Dashboard.tsx";
import Invoicedetails from "../Components/MainComponents/DashboardComponents/Invoice/Invoicedetails.tsx";
import Agreement from "../Components/MainComponents/Agreement.tsx";
import NonTransport from "../Components/MainComponents/DashboardComponents/NonTransport.tsx";
import { ApiDecodeTempToken, ApiUsersLogin } from "../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import MyTaskLayout from "../Components/MainComponents/DashboardComponents/MyTaskLayout.tsx";
import More from "../Components/MainComponents/DashboardComponents/More.tsx";
import ReCheck from "../Components/MainComponents/DashboardComponents/ReCheck.tsx";
import UnAuthorizeAccess from "../Components/MainComponents/UnAuthorizeAccess.tsx";
// import ALDICreateOrEditScoreCard from "../Components/MainComponents/ScoreCardComponents/ALDICreateOrEditScoreCard.tsx";
import Faq from "../Components/MainComponents/DashboardComponents/FAQ/Faq.tsx";
import ViewAllIMages from "../Components/MainComponents/ScoreCardComponents/ViewAllIMages.tsx";
import TrainingCalendar from "../Components/MainComponents/DashboardComponents/TrainingCalendar.tsx";
import OtpVerification from "../Components/Layouts/OtpVerification.tsx";

const AppRoutes: React.FC = () => {
  const location = useLocation()
  const AuthRoutes = [
    "/login",
    "/createShopper",
    "/otp",
    "/setpassword",
    "/verify"
  ];
  const isAuth = AuthRoutes.some((route) => location.pathname.startsWith(route));
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token')
  const value1 = params.get('adminuserid');
  const value2 = params.get('validation');
  const reporttoken = params.get('x-z-a');
  const isTransport = localStorage.getItem('isTransport')
  const navigate = useNavigate()
  const [reportdata, setreportdata] = useState<any>([])
  const [random_string, setrandom_string] = useState<string>(localStorage.getItem('localstring') ?? '')

  const Autologin = async () => {
    try {
      const data = {
        loginType: 'tokenLogin',
        adminId: value1,
        loginToken: value2,
        ipAddress: "127.0.0.1",
        browserName: "Chrome"
      }
      const response: any = await ApiUsersLogin(data);
      if (response.status) {
        // console.log(response)
        const userData = {
          'userId': response.userDetails.userId,
          'shopperAgreementFileUrl': response.userDetails.shopperAgreementFileUrl,
          'isCompletedForm1': response.userDetails.isShopperStep1DocumentSubmitted,
          'isCompletedAllForm': response.userDetails.isShopperAllDocumentSubmitted,
          'userStatus': response.userDetails.userStatus.userStatus,
          'isLatestAgreementSigned': response.userDetails.isLatestAgreementSigned,
        }
        localStorage.setItem('userData', JSON.stringify(response.userDetails));
        localStorage.setItem('userOthreData', JSON.stringify(response.otherDetails));
        localStorage.setItem('token', response?.token || 0);
        localStorage.setItem('isTransport', response.otherDetails?.isShopperCanWorkForTransport);
        localStorage.setItem('ActiveTask', 'Dashboard');

        if (userData.userStatus === 'delete') {
          toast.error("Account not found")
          localStorage.clear()
          navigate('/login')
        }
        // else if (userData.shopperAgreementFileUrl == null || userData.isLatestAgreementSigned === false) {
        //   navigate('/agreement')
        // }
        else if (userData.isCompletedForm1) {
          // if()
          if (userData.isCompletedAllForm && userData.userStatus === 'active') {
            setTimeout(() => {
              navigate('/dashboard/dashboard')
            }, 200);
            // navigate('/terms')
          }
          else if (userData.userStatus === 'approve') {
            navigate('/applicationform2')
          }
          else {
            navigate('/applicationform')
          }
        }
        else {
          navigate('/applicationform')
        }
      }
      else {
        toast.error('Invalid Access')
      }
    } catch (error) {

    }
  }

  function generateRandomString(length:any) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

  const ReportLogin = async () => {
    try {
      const data = {
        token: reporttoken
      }
      localStorage.clear()
      const res = await ApiDecodeTempToken(data)
      console.log("Response", res)
      if (res.success) {
        localStorage.setItem('token', res?.data?.auth)
        localStorage.setItem('liveuserRole', res?.data?.tokenGeneratedByUserRole)
        localStorage.setItem('liveuserId', res?.data?.tokenGeneratedById)
        localStorage.setItem('liveclientGroup', res?.data?.clientGroupName)
        const randomstring = generateRandomString(12);
        setreportdata(res.data)
        await setrandom_string(randomstring)
        localStorage.setItem('localstring',randomstring)
        navigate(`/${randomstring}`,{state:{allocationId: res?.data?.allocationId, clientGroup: res?.data?.clientGroupName}})
      }
    } catch (error) {
        console.log("Eror", error)
    }
  }
  useEffect(() => {
    if (value2) {
      Autologin()
    }
    if (token) {
      localStorage.setItem('token', token)
    }
    if (reporttoken) {
      ReportLogin()
    }
  }, [params])


  const shopperautologin = () => {
    try {
      const userToken = localStorage.getItem('token')
      const userData = localStorage.getItem('userData')

      const currentPath = window.location.pathname

      // No token → login
      if (!userToken || !userData) {
        if (currentPath !== '/login') {
          navigate('/login', { replace: true })
        }
        return
      }

      // Validate role
      if (!userData) {
        toast.error("Invalid Access")
        navigate('/login', { replace: true })
        return
      }

      // Only redirect to dashboard when visiting login
      if (currentPath === '/login' || currentPath === '/') {
        const redirectUrl = '/dashboard/dashboard'
        navigate(redirectUrl, { replace: true })
      }

      // Otherwise stay on the current route
    } catch (error) {
      console.log("Error during autologin", error)
    }
  }

  useEffect(() => {
    shopperautologin()
  }, [])
  return (
    <Box display='flex' alignItems='center' width='100%' height='fit-content'>
      {isAuth &&
        <Box width='50%' display={{ xs: 'none', md: 'flex' }} alignItems='center'>
          <LeftSide></LeftSide>
        </Box>
      }

      <Box width={isAuth ? { xs: '100%', lg: '50%' } : '100%'}>
        <Provider store={store}><Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/verify" element={<OtpVerification />} />
          <Route path="/" element={value2 ? <Navigate to='/dashboard/dashboard' /> : <Navigate to="/login" />} />
          <Route path="/createShopper" element={<CreateShopper />} />
          <Route path="/otp" element={<ProtectedRoute requiredstep='otp'><Otp /></ProtectedRoute>} />
          <Route path="/setpassword" element={<ProtectedRoute requiredstep='setpassword'><SetPassword /></ProtectedRoute>} />
          <Route path="/applicationform" element={
            <PrivateRoute>
              <Applicationform />
            </PrivateRoute>
          } />
          <Route path="/applicationform2" element={<PrivateRoute><Applicationform2 /></PrivateRoute>} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/agreement" element={<Agreement />} />
          <Route path="/dashboard/dashboard" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
          <Route path="/dashboard/dateChange" element={<PrivateRoute><Layout><ReCheck /></Layout></PrivateRoute>} />
          <Route path="/dashboard/more" element={<PrivateRoute><Layout><More /></Layout></PrivateRoute>} />
          <Route path="/dashboard/myTasks" element={<PrivateRoute><MyTaskLayout /></PrivateRoute>}>
            <Route index element={<PrivateRoute><Layout><MyTask /></Layout></PrivateRoute>} />
          <Route path="/dashboard/myTasks/Questions" element={<PrivateRoute><Layout><Questions /></Layout></PrivateRoute>} />
            {/* <Route path="createOrEditScoreCard" element={<PrivateRoute><Layout><CreateOrEditScoreCard /></Layout></PrivateRoute>} /> */}
            <Route path="createOrEditScoreCard" element={<PrivateRoute><Layout><CreateOrEditScoreCard/></Layout></PrivateRoute>} />
          </Route>
          <Route path={`/${random_string}`} element={random_string?.length > 0 ? <CreateOrEditScoreCard />:<UnAuthorizeAccess/> } />
          <Route path={`/all-images/${random_string}`} element={random_string?.length > 0 ? <ViewAllIMages />:<UnAuthorizeAccess/> } />
          <Route path="/dashboard/myTasks" element={<PrivateRoute><Layout><MyTask /></Layout></PrivateRoute>} />
          <Route path="/dashboard/myprofile" element={<PrivateRoute><Layout><Profile /></Layout></PrivateRoute>} />
          <Route path="/dashboard/Scorecards" element={<PrivateRoute><Layout><ScoreCard /></Layout></PrivateRoute>} />
          <Route path="/dashboard/Invoices" element={<PrivateRoute><Layout><Invoices /></Layout></PrivateRoute>} />
          <Route path="/dashboard/Transport" element={<PrivateRoute><Layout>{isTransport === 'true' ? <Transport /> : <NonTransport />}</Layout></PrivateRoute>} />
          <Route path="/dashboard/FixIt" element={<PrivateRoute><Layout><FixIt /></Layout></PrivateRoute>} />
          <Route path="/dashboard/Faq" element={<PrivateRoute><Layout><Faq/></Layout></PrivateRoute>} />
          <Route path="/dashboard/Apply" element={<PrivateRoute><Layout><ApplyTask /></Layout></PrivateRoute>} />
          <Route path="/dashboard/Invitations" element={<PrivateRoute><Layout><Invitations /></Layout></PrivateRoute>} />
          <Route path="/dashboard/Calendar" element={<PrivateRoute><Layout><Calendar /></Layout></PrivateRoute>} />
          <Route path="/dashboard/trainingCalendar" element={<PrivateRoute><Layout><TrainingCalendar /></Layout></PrivateRoute>} />
          <Route path="/ShopperExperience" element={<PrivateRoute><ShopperExperience /></PrivateRoute>} />
          {/* <Route path="/dashboard/myTask/createOrEditScoreCard/:allocationId" element={<PrivateRoute><Layout><CreateOrEditScoreCard /></Layout></PrivateRoute>} /> */}
          <Route path="/dashboard/invoices/invoice-details" element={<PrivateRoute><Layout><Invoices /></Layout></PrivateRoute>} />
        </Routes>
        </Provider>

      </Box>

    </Box>
  );
};

export default AppRoutes;
